const manuServiceSections = document.querySelectorAll(
  "section.manufacturing-services"
);
manuServiceSections.forEach( ( section ) => {
  let idx = 0;
  const overlays = section.querySelectorAll( ".slider .group .overlay" );
  const slider = tns( {
    container: section.querySelector( ".slider" ),
    items: 1,
    autoplay: false,
    controls: true,
    nav: false,
    loop: false,
    autoplayButtonOutput: false,
    controlsContainer: section.querySelector( ".manufacturing-slider-controls" ),
    speed: 400,
    fixedHeight: true,
    responsive: {
      300: {
        items: 1,
      },
      768: {
        items: 1.5,
        gutter: 16,
        fixedWidth: 450, // 👈 okay for tablet+
      },
      1024: {
        items: 2,
        gutter: 16,
        fixedWidth: 450,
      },
    },
  } );

  slider.events.on( "indexChanged", function ( info ) {
    idx = info.index;
    handleOpacity();
  } );
  function handleOpacity () {
    for ( let i = 0; i < overlays.length; i++ ) {
      overlays[ i ].style.opacity = i > ( idx + 1 ) || i < idx ? 0.85 : 0;
    }
    // console.log( "idx", JSON.stringify( idx, null, 2 ) );
  }
  handleOpacity();
} );
